module.exports = __webpack_public_path__ + "img/kjsy_gallery2.99182814.jpg";